import { AfterViewInit, Component, ElementRef, NgZone, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "../auth.service";
import { environment } from "../../../environments/environment";
import { JwTokenModel, UserModel } from "../../core/api/models";
import { HttpClient, HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { map, tap } from "rxjs/operators";
import { Utils } from "../../core/utils";
import { AlertService } from "../../shared/services/alert.service";



@Component({
  selector: 'app-error-component',
  templateUrl: './error.component.html',
  styleUrl: './error.component.css',
  standalone: false
})
export class ErrorComponent implements OnInit, AfterViewInit {
  

  errorMessage: string | undefined | null;

  
  constructor(private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private ngZone: NgZone,
    private http: HttpClient,
    private alertService: AlertService) {
  }


  ngOnInit(): void {

    console.debug('ErrorComponent.ngOnInit');
    this.errorMessage = 'Error';

    this.route.queryParams.subscribe(params => {
      this.errorMessage = params['errorMessage'];

      let unauthorized = params['unauthorized'];

      if (unauthorized) {
        if (params['missingTwoFactor'])
          this.errorMessage = `You need to validate your 2 factor authentication to access the page ${unauthorized}.`;
        else
          this.errorMessage = `You are not authorized to access the page ${unauthorized}.`;
        this.alertService.error(this.errorMessage);
      }
      

    });
    


    
    
  
  }

  ngAfterViewInit(): void {
    

    console.debug('ErrorComponent.AfterViewInit');



    
    

    
    if (this.errorMessage) {
      

      console.warn('Error Message', this.errorMessage);
      /*
      this.authService.getTokenInfo()
        .forEach(response => {
            this.authService.getUserInfo().subscribe(x => {
              this.authService.redirectAfterLogin(x, this.returnUrl);
            });
        })
        .catch(
          err => {
            this.checkingCredential = false;
            this.alertService.error(err.Message ||  'You are logged on another device.');
          })
        .finally(() => {
        
          //
        });
        */
    }
  }

  

}
